import { useQuery, queryCache } from "react-query"
import { ApplicationDispatch } from '../store/application/types';
import { fetchData, postData } from './fetch';
import { useDispatch } from 'react-redux';
import { EmployeeUpdate, IEmployee } from "../Interfaces/Admin/IEmployee";

export const useEmployees = () => {
  const dispatch = useDispatch<ApplicationDispatch>();

  const getEmployees = async (key: string) => {
    const url = `api/Employee/List`;
    const response = await fetchData(url, dispatch) as IEmployee[];
    return response;
  };

  return useQuery(
    ['Employees'],
    getEmployees,
    {
    }
  );
}

export const useEmployee = (id?: string) => {
  const dispatch = useDispatch<ApplicationDispatch>();

  const getEmployee = async (key: string, id?: string) => {
    if (id) {
      const url = `api/Employee/${id}`;
      const response = await fetchData(url, dispatch) as IEmployee;
      return response;
    } else {
      return undefined;
    }
  };

  return useQuery(
    ['Employees', id],
    getEmployee,
    {
      refetchOnWindowFocus: false,
    }
  );
}

export const updateEmployee = async (employee: EmployeeUpdate) => {
  const url = `api/Employee/Update`;
  const response = await postData(url, employee) as {};
  queryCache.refetchQueries('Employees');
  return response;
}
